module.exports = __webpack_public_path__ + "static/saas-view-1-5992ad1c1d5cd09a5e0c0ba284cfd808.svg";